// REACT
import React from 'react';

// MATERIAL UI
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import { LinearProgress } from 'material-ui/Progress';

export default () => (
  <div>
    <AppBar position="static">
      <Toolbar>
        <Typography type="title" color="inherit">
          {'Loading'}
        </Typography>
      </Toolbar>
    </AppBar>
    <LinearProgress color="accent" />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Loading/index.js